/**
 * Module for selecting the action item type in the wizard
 */
define([
  "marionette",
  "messaging/messenger",
  "./actionItemSelectView",
  "modules/actions/actionGroup/actionGroupItems/actionGroupItemsModel",
], function (Marionette, Messenger, ActionItemSelectView, ActionGroupItemsModel) {
  var ActionItemSelectModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "actionItemSelect";
      this.region = options.region;
    },
    show: function () {
      this.view = new ActionItemSelectView.actionItemSelectView();
      this.view.on(
        "open:api:request",
        function () {
          var apiRequest = new ActionGroupItemsModel.apiRequest();
          Messenger.vent.trigger("edit:api:request", apiRequest);
        },
        this,
      );

      this.view.on(
        "open:transformation",
        function () {
          var transformation = new ActionGroupItemsModel.transformation();
          Messenger.vent.trigger("edit:transformation:action", transformation);
        },
        this,
      );

      this.showRegion(this.view);
    },
  });

  return ActionItemSelectModule;
});
